import { Grid2, Typography, Box } from "@mui/material";
import { Button, Input } from "@aidergroup/ui-v2";
import { i18n } from "@/utils/i18n";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import schemas from "@/utils/schemas";
import React from "react";
import { Forms } from "@/types/form";
import useUser from "@/context/user";
import constant from "@/utils/constant";
import { useSubmit } from "./hooks";
import FileUpload from "../../common/file-upload";
import { stringToColor } from "@/utils/helpers";

const Profile: React.FC = () => {
    const user = useUser(state => state);
    const inputSpacing = constant.GRID_INPUT_SPACING;
    const sectionSpacing = constant.GRID_SECTION_SPACING;

    const firstName = user.displayName?.split(" ")[0] ?? "";
    const lastName = user.displayName?.split(" ")[1] ?? "";

    const firstLetter = user.email?.[0]?.toUpperCase() ?? "";
    const color = stringToColor(user.email ?? "u");

    const {
        control,
        setValue,
        handleSubmit,
        formState: { isSubmitting, isDirty },
        watch,
    } = useForm<Forms["Profile"]>({
        resolver: yupResolver(schemas.profile),
        values: {
            photoURL: user.photoURL ?? "",
            firstName: firstName ?? "",
            lastName: lastName ?? "",
            email: user.email ?? "",
        },
    });

    const onSubmit = useSubmit();

    return (
        <Box component="form" onSubmit={handleSubmit(async data => await onSubmit(data))}>
            <Grid2
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={inputSpacing}
                marginBottom={sectionSpacing}
            >
                <FileUpload
                    setValue={setValue}
                    watch={watch}
                    firstLetter={firstLetter}
                    bgColor={color}
                />
                <Typography variant="h4" color="black">{`${firstName} ${lastName}`}</Typography>
            </Grid2>
            <Grid2 container direction="column" alignItems="center" spacing={sectionSpacing}>
                <Grid2 container spacing={inputSpacing}>
                    <Grid2 size={4}>
                        <Input
                            control={control}
                            name="email"
                            label={i18n.t("label.email")}
                            placeholder={i18n.t("placeholder.email")}
                            type="text"
                            disabled={true}
                            fullWidth
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Input
                            control={control}
                            name="firstName"
                            label={i18n.t("label.firstName")}
                            placeholder={i18n.t("placeholder.firstName")}
                            type="text"
                            fullWidth
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Input
                            control={control}
                            name="lastName"
                            label={i18n.t("label.lastName")}
                            placeholder={i18n.t("placeholder.lastName")}
                            type="text"
                            fullWidth
                        />
                    </Grid2>
                </Grid2>
                <Grid2>
                    <Button
                        variant="contained"
                        type="submit"
                        loading={isSubmitting}
                        disabled={!isDirty}
                    >
                        {i18n.t("button.updateProfile")}
                    </Button>
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default Profile;
